import { action, autorun, computed, decorate, extendObservable, reaction } from "mobx";
import _ from "lodash";
import queryString from "query-string";
import { RouteConstants } from "../../constants/RouteConstants";

class OrgAdminStore {
  constructor(authStore, commonStore, compTixApi, routerStore, loadingStore) {
    this.authStore = authStore;
    this.commonStore = commonStore;
    this.compTixApi = compTixApi;
    this.routerStore = routerStore;
    this.loadingStore = loadingStore;

    this.defaults = {
      addOns: [],
      selectedYear: { value: -1, label: "" },
      year: new Date().getFullYear(),
      isOrgEnabled: false,
      orgId: null,
      orgSetting: {},
      currentSeasons: []
    };

    extendObservable(this, {
      addOns: this.defaults["addOns"],
      selectedYear: this.defaults["selectedYear"],
      isOrgEnabled: this.defaults["isOrgEnabled"],
      orgSetting: this.defaults["orgSetting"],
      currentSeasons: this.defaults["currentSeasons"],
      setAddOns: action(value => {
        this.addOns = value;
      }),
      setOrgSetting: action(value => {
        this.orgSetting = value;
      }),
      setCurrentSeasons: action(value => {
        this.currentSeasons = value;
      }),
      setSelectedYear: action(value => {
        this.selectedYear = value;
        this.routerStore.history.push({
          pathname: this.routerStore.location.pathname,
          search: "?year=" + this.selectedYear.value
        });
      }),
      setIsOrgEnabled: action(value => {
        this.isOrgEnabled = value;
      }),
      toggleIsOrgEnabled: action(() => {
        this.isOrgEnabled = !this.isOrgEnabled;
      }),
      resetStore: action(() => {
        this.selectedYear = this.defaults["selectedYear"];
      }),
      updateFromUrlParams: action(search => {
        const params = queryString.parse(search);
        this.year = params["year"] * 1 || this.defaults["year"];
        this.selectedYear = params["year"] ? { value: this.year, label: this.year } : this.defaults["selectedYear"];
      }),
      addNewAddOn: action(season => {
        this.addOns.push({ season: season, org: this.commonStore.currentOrg, departments: [], homeAwayTypes: [] });
      }),
      triggerChange: action(addOn => {})
    });

    autorun(() => {
      if (this.routerStore.isOrgAdminTab && this.commonStore.currentOrgId && this.getSelectedYear.value !== -1) {
        this.compTixApi.getOrgSettings(this.commonStore.currentOrgId).then(setting => {
          this.setIsOrgEnabled(setting.useTicketAddOns);
          this.setOrgSetting(setting);

          this.compTixApi.getAddOnsForOrg(this.commonStore.currentOrgId).then(addOns => {
            this.setAddOns(addOns);
          });

          this.compTixApi.getCurrentSeasons().then(data => {
            let activeSeasons = data.seasons
              .filter(s => s.year === this.getSelectedYear.value)
              .sort((a, b) => a.seasonType.seasonTypeId - b.seasonType.seasonTypeId);
            this.setCurrentSeasons(activeSeasons);
          });
        });
      }
    });
  }

  save = () => {
    this.loadingStore.setLoading(true);
    this.orgSetting.useTicketAddOns = this.isOrgEnabled;
    this.compTixApi.saveOrgSetting(this.orgSetting);
    this.compTixApi.saveAddOns(this.addOns).then(_ => {
      this.loadingStore.setLoading(false);
    });
  };

  get getSelectedYear() {
    return this.selectedYear.value === -1 && this.commonStore.yearsDropdownList.length > 0
      ? this.commonStore.yearsDropdownList.find(y => {
          return y.value === this.commonStore.currentSeason.year;
        })
      : this.selectedYear;
  }

  get departmentOptions() {
    return this.commonStore.departmentTypes
      ? this.commonStore.departmentTypes.map(d => ({
          label: d.departmentName,
          value: d.departmentTypeId,
          departmentType: d
        }))
      : [{}];
  }

  get homeAwayOptions() {
    return this.commonStore.homeAwayOptions.map(d => ({
      label: d.value.homeAwayTypeName,
      value: d.value.homeAwayTypeId,
      homeAwayType: d.value
    }));
  }
}

decorate(OrgAdminStore, {
  getSelectedYear: computed,
  departmentOptions: computed,
  homeAwayOptions: computed
});

export default OrgAdminStore;
